module.exports = __webpack_public_path__ + "img/king_tours.4e0e8ace.webp";